export enum FeatureFlags {
  ReserveAccessories = 'RESERVE_ACCESSORIES',
  InstantInterview = 'INSTANT_INTERVIEW',
  BookAppointment = 'BOOK_APPOINTMENT',
  NavigationActivePage = 'NAVIGATION_ACTIVE_PAGE'
}

export enum VariantNames {
  WithActiveState = 'WITH_ACTIVE_STATE'
}
